<div class="flex flex-row gap-4">
  <div class="flex-1 flex flex-col gap-4">
    <div class="card shadow-sm">
      <div class="card-body p-3 gap-2">
        <div class="type-section-title">Miscellaneous</div>

        <div class="form-control">
          <label class="label cursor-pointer label-option">
            <span class="label-text">
              Analytics
              <app-icon
                name="gameHelp"
                size="inline"
                class="text-lighter"
                [tp]="'Analytics are not tied to your email or any identifying information. What is collected: events related to game progress, discoveries, and in-game actions. Analytics cannot be enabled when the game is played in an embedded environment.'"
                [tpPlacement]="'top'"
              />
            </span>
            <input
              type="checkbox"
              [checked]="getOption('analyticsEnabled')"
              [disabled]="!canAnalyticsActivate()"
              class="checkbox"
              (click)="
                setOption('analyticsEnabled', !getOption('analyticsEnabled'))
              "
            />
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
